export class CanvasSizeModel {
    constructor(
        public label: string,
        public width: number,
        public height: number
    ) {}
}
